// extracted by mini-css-extract-plugin
export var centered = "styles-module--centered--1bc40";
export var description = "styles-module--description--bdc68";
export var title = "styles-module--title--fe4be";
export var titleContainer = "styles-module--titleContainer--0e05e";